var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"stand-with-israel-footer"},[_vm._v(" Funds are distributed to Israel emergency organizations through "),_c('a',{attrs:{"href":_vm.org.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.org.name))]),_vm._v(" Tax ID: "+_vm._s(_vm.org.taxId)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }